import type {
    EmailInsightType,
    FileInsightType,
    InsightsDataFetchSource,
} from 'owa-meeting-insights-types-and-flights';
import type RequestStatus from '../store/schema/RequestStatus';
import { action } from 'satcheljs';

export const setMeetingInsights = action(
    'setMeetingInsights',
    (
        meetingId: string,
        status: RequestStatus,
        files: FileInsightType[],
        emails: EmailInsightType[],
        traceId: string,
        dataFetchSource: InsightsDataFetchSource,
        requestTimestamp: number,
        logicalId: string
    ) => ({
        meetingId,
        status,
        files,
        emails,
        traceId,
        dataFetchSource,
        requestTimestamp,
        logicalId,
    })
);

export const tryAddToPendingServiceQueue = action(
    'tryAddToPendingServiceQueue',
    (meetingId: string, dataFetchSource: InsightsDataFetchSource) => ({
        meetingId,
        dataFetchSource,
    })
);

export const tryRemoveFromPendingServiceQueue = action(
    'tryRemoveFromPendingServiceQueue',
    (meetingId: string, dataFetchSource: InsightsDataFetchSource) => ({
        meetingId,
        dataFetchSource,
    })
);

export const setInsightsLogicalId = action(
    'setInsightsLogicalId',
    (meetingId: string, logicalId: string, dataFetchSource: InsightsDataFetchSource) => ({
        meetingId,
        logicalId,
        dataFetchSource,
    })
);
